/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useFoxTopUpStore } from "../store";
import { useFetchActivityInfoList } from "./useFetchActivityInfoList";
import { BindActivityInfo } from "@/components/top-up/types";
import { AnimationCommonContainer } from "../atom";
import { AnimationBalanceRecharge } from "../components/fox-balance-recharge";
import { useFetchHangTags } from "./useFetchHangTags";

export function useInitTabList() {
  const { t } = useTranslation("topup");
  useFetchActivityInfoList();
  useFetchHangTags();
  const { setter: setFoxTopUpStore } = useFoxTopUpStore();
  const activityInfoList = useFoxTopUpStore((state) => state.activityInfoList);
  const activeName = useFoxTopUpStore((state) => state.activeName);
  const haveRechargeGiftCouponActivity = useFoxTopUpStore(
    (state) => state.haveRechargeGiftCouponActivity
  );
  const rechargeGiftCouponActivity = useFoxTopUpStore(
    (state) => state.rechargeGiftCouponActivity
  );
  const location = useLocation();

  const rechargeGiftBalanceTabItem = useCallback(
    (activityInfo: BindActivityInfo) => {
      return {
        label: t("topUp_recharge_tab"),
        key: activityInfo.id.toString(),
        advertiseImg: activityInfo.imageUrlLink,
        advertiseLink: activityInfo.imageUrlLinkEventDetails,
        children: (
          <AnimationCommonContainer>
            <AnimationBalanceRecharge activityInfo={activityInfo} />
          </AnimationCommonContainer>
        ),
      };
    },
    [rechargeGiftCouponActivity]
  );

  const getTabsList = useCallback(() => {
    const defaultBalanceTabItem = {
      label: t("topUp_recharge_tab"),
      key: "balance-recharge",
      advertiseImg: "",
      advertiseLink: "",
      children: (
        <AnimationCommonContainer>
          <AnimationBalanceRecharge />
        </AnimationCommonContainer>
      ),
    };
    // 动画活动包括 充值赠送券、青云券充值、抽奖券
    // 动画抽奖券和充值赠送可能同时存在
    const tabList = [
      haveRechargeGiftCouponActivity()
        ? rechargeGiftBalanceTabItem(rechargeGiftCouponActivity())
        : defaultBalanceTabItem,
    ];
    return tabList;
  }, [
    activityInfoList,
    activeName,
    location,
    rechargeGiftBalanceTabItem,
    haveRechargeGiftCouponActivity,
    rechargeGiftCouponActivity,
  ]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const activeNameValue = params.get("activeName");
    if (activeNameValue) {
      if (
        activityInfoList.length > 0 &&
        activityInfoList.find((item) => item.activityName === activeNameValue)
      ) {
        setFoxTopUpStore((state) => {
          state.activeName = activeNameValue;
        });
      } else {
        setFoxTopUpStore((state) => {
          state.activeName = getTabsList()[0].key;
        });
      }
    } else {
      setFoxTopUpStore((state) => {
        state.activeName = getTabsList()[0].key;
      });
    }
  }, [activityInfoList, location, activeName]);

  return {
    getTabsList,
  };
}
